module.exports = "/_next/static/images/PersonalizeAcrossSitesAppsChannels@2x-6734c41cbbd2f0b7e8acfa6e4e0ad7cc.png";